import React from 'react'

const Faq = () => {
  return (
    <div>
      <h1>This is faq</h1>
    </div>
  )
}

export default Faq
